<template>
    <div>
        <!-- Full-screen loading overlay -->
        <v-overlay v-model="pageLoading" class="align-center justify-center" persistent>
            <div class="text-center">
                <v-progress-circular
                    indeterminate
                    size="64"
                    color="primary"
                ></v-progress-circular>
                <div class="mt-4 text-h6">Đang tải dữ liệu...</div>
            </div>
        </v-overlay>

        <!-- Card thêm quiz category -->
        <v-card class="mb-6">
            <v-card-title class="text-h6">
                <v-icon class="mr-2">mdi-plus-circle</v-icon>
                Thêm danh mục quiz mới
            </v-card-title>
            <v-card-text>
                <v-form ref="quizCategoryForm">
                    <v-row>
                        <v-col md="6">
                            <v-text-field 
                                v-model="newQuizCategory.name" 
                                label="Tên danh mục" 
                                placeholder="Nhập tên danh mục quiz..."
                                variant="outlined" 
                                density="compact"
                                :rules="[v => !!v || 'Tên danh mục là bắt buộc']">
                            </v-text-field>
                        </v-col>
                        <v-col md="6">
                            <v-text-field 
                                v-model="newQuizCategory.icon" 
                                label="Icon" 
                                placeholder="Nhập tên icon (tùy chọn)..."
                                variant="outlined" 
                                density="compact">
                            </v-text-field>
                        </v-col>
                        <v-col md="12">
                            <v-textarea 
                                v-model="newQuizCategory.description" 
                                label="Mô tả" 
                                placeholder="Nhập mô tả danh mục..."
                                variant="outlined" 
                                density="compact"
                                rows="3"
                                :rules="[v => !!v || 'Mô tả là bắt buộc']">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-form>
                <v-row>
                    <v-col cols="12" class="d-flex justify-center">
                        <v-btn 
                            color="primary" 
                            variant="elevated" 
                            @click="addQuizCategory" 
                            :disabled="!newQuizCategory.name || !newQuizCategory.description"
                            :loading="loading">
                            <v-icon class="mr-2">mdi-plus</v-icon>
                            Tạo mới
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- Table danh sách quiz category -->
        <v-card>
            <v-card-title class="text-h6">
                <v-icon class="mr-2">mdi-help-circle-multiple</v-icon>
                Danh sách danh mục quiz
            </v-card-title>
            <v-card-text>
                <v-table class="elevation-1">
                    <thead>
                        <tr>
                            <th class="text-left">Tên danh mục</th>
                            <th class="text-left">Mô tả</th>
                            <th class="text-center">Icon</th>
                            <th class="text-center">Số câu hỏi</th>
                            <th class="text-center">Trạng thái</th>
                            <th class="text-center">Thao tác</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="category in quizCategories" :key="category.id">
                            <td>{{ category.name }}</td>
                            <td>{{ category.description }}</td>
                            <td class="text-center">
                                <v-icon v-if="category.icon" size="small">{{ category.icon }}</v-icon>
                                <span v-else>-</span>
                            </td>
                            <td class="text-center">{{ category.questionCount || 0 }}</td>
                            <td class="text-center">
                                <v-chip :color="category.status === 1 ? 'success' : 'error'" size="small">
                                    {{ category.status === 1 ? 'Hoạt động' : 'Tạm ẩn' }}
                                </v-chip>
                            </td>
                            <td class="text-center">
                                <div class="d-flex justify-center">
                                    <v-btn 
                                        icon 
                                        size="small" 
                                        color="primary" 
                                        @click="editQuizCategory(category)"
                                        class="mr-2">
                                        <v-icon>mdi-pencil</v-icon>
                                    </v-btn>
                                    <v-btn 
                                        icon 
                                        size="small" 
                                        :color="category.status === 0 ? 'success' : 'error'"
                                        @click="toggleStatus(category)"
                                        class="mr-2">
                                        <v-icon>
                                            {{ category.status === 0 ? 'mdi-eye' : 'mdi-eye-off' }}
                                        </v-icon>
                                    </v-btn>
                                    <v-btn 
                                        icon 
                                        size="small" 
                                        color="red"
                                        @click="deleteQuizCategory(category)">
                                        <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card-text>
        </v-card>

        <!-- Dialog edit quiz category -->
        <v-dialog v-model="editDialog" max-width="600" persistent>
            <v-card v-if="editingCategory.name !== undefined">
                <v-card-title class="text-h6">
                    <v-icon class="mr-2">mdi-pencil</v-icon>
                    Chỉnh sửa danh mục quiz
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col md="6">
                            <v-text-field 
                                v-model="editingCategory.name" 
                                label="Tên danh mục" 
                                variant="outlined"
                                density="compact" 
                                :rules="[v => !!v || 'Tên danh mục là bắt buộc']">
                            </v-text-field>
                        </v-col>
                        <v-col md="6">
                            <v-text-field 
                                v-model="editingCategory.icon" 
                                label="Icon" 
                                variant="outlined"
                                density="compact">
                            </v-text-field>
                        </v-col>
                        <v-col md="12">
                            <v-textarea 
                                v-model="editingCategory.description" 
                                label="Mô tả" 
                                variant="outlined"
                                density="compact"
                                rows="3"
                                :rules="[v => !!v || 'Mô tả là bắt buộc']">
                            </v-textarea>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" variant="text" @click="closeEditDialog">
                        Hủy
                    </v-btn>
                    <v-btn color="primary" variant="elevated" @click="updateQuizCategory" :loading="updateLoading">
                        Cập nhật
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Dialog confirm delete -->
        <v-dialog v-model="deleteDialog" max-width="400" persistent>
            <v-card>
                <v-card-title class="text-h6">
                    <v-icon class="mr-2" color="red">mdi-delete-alert</v-icon>
                    Xác nhận xóa
                </v-card-title>
                <v-card-text>
                    Bạn có chắc chắn muốn xóa danh mục "{{ deletingCategory?.name }}"? 
                    Thao tác này không thể hoàn tác.
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="grey" variant="text" @click="closeDeleteDialog">
                        Hủy
                    </v-btn>
                    <v-btn color="red" variant="elevated" @click="confirmDelete" :loading="deleteLoading">
                        Xóa
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Snackbar thông báo -->
        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000" top right>
            {{ snackbarText }}
        </v-snackbar>
    </div>
</template>

<script>
import axios from '../http';

export default {
    name: 'QuizCategory',
    data() {
        return {
            newQuizCategory: {
                name: '',
                description: '',
                icon: ''
            },
            loading: false,
            pageLoading: false,
            editDialog: false,
            deleteDialog: false,
            updateLoading: false,
            deleteLoading: false,
            editingCategory: {},
            deletingCategory: null,
            quizCategories: [],
            snackbar: false,
            snackbarText: '',
            snackbarColor: 'success'
        }
    },
    mounted() {
        this.fetchQuizCategories(true);
    },
    methods: {
        async fetchQuizCategories(showPageLoading = false) {
            if (showPageLoading) {
                this.pageLoading = true;
            }
            
            try {
                const response = await axios.get('/admin/quiz-category');
                this.quizCategories = response.data;
            } catch (error) {
                console.error('Error fetching quiz categories:', error);
                this.showSnackbar('Lỗi khi tải danh sách danh mục', 'error');
            } finally {
                if (showPageLoading) {
                    this.pageLoading = false;
                }
            }
        },

        async addQuizCategory() {
            if (!this.newQuizCategory.name || !this.newQuizCategory.description) return;

            this.loading = true;
            try {
                const payload = {
                    name: this.newQuizCategory.name,
                    description: this.newQuizCategory.description
                };
                if (this.newQuizCategory.icon) {
                    payload.icon = this.newQuizCategory.icon;
                }

                const response = await axios.post('/admin/quiz-category', payload);
                const newCategory = response.data;
                
                this.quizCategories.unshift({
                    id: newCategory.id,
                    name: newCategory.name,
                    description: newCategory.description,
                    icon: newCategory.icon,
                    questionCount: 0,
                    status: newCategory.status || 1
                });

                this.newQuizCategory = { name: '', description: '', icon: '' };
                this.$refs.quizCategoryForm.resetValidation();
                this.showSnackbar('Thêm danh mục thành công', 'success');
            } catch (error) {
                console.error('Error adding quiz category:', error);
                this.showSnackbar('Lỗi khi thêm danh mục', 'error');
            } finally {
                this.loading = false;
            }
        },

        editQuizCategory(category) {
            this.editingCategory = { ...category };
            this.editDialog = true;
        },

        async updateQuizCategory() {
            if (!this.editingCategory.name || !this.editingCategory.description) return;

            this.updateLoading = true;
            try {
                const payload = {
                    name: this.editingCategory.name,
                    description: this.editingCategory.description
                };
                if (this.editingCategory.icon) {
                    payload.icon = this.editingCategory.icon;
                }

                await axios.put(`/admin/quiz-category/${this.editingCategory.id}`, payload);
                
                const index = this.quizCategories.findIndex(cat => cat.id === this.editingCategory.id);
                if (index !== -1) {
                    this.quizCategories[index] = { ...this.quizCategories[index], ...payload };
                }
                
                this.editDialog = false;
                this.showSnackbar('Cập nhật danh mục thành công', 'success');
            } catch (error) {
                console.error('Error updating quiz category:', error);
                this.showSnackbar('Lỗi khi cập nhật danh mục', 'error');
            } finally {
                this.updateLoading = false;
            }
        },

        async toggleStatus(category) {
            try {
                const newStatus = category.status === 1 ? 0 : 1;
                await axios.put(`/admin/quiz-category/${category.id}/status`, { status: newStatus });
                
                const index = this.quizCategories.findIndex(cat => cat.id === category.id);
                if (index !== -1) {
                    this.quizCategories[index].status = newStatus;
                }
                
                this.showSnackbar(`${newStatus === 1 ? 'Kích hoạt' : 'Ẩn'} danh mục thành công`, 'success');
            } catch (error) {
                console.error('Error toggling status:', error);
                this.showSnackbar('Lỗi khi thay đổi trạng thái', 'error');
            }
        },

        deleteQuizCategory(category) {
            this.deletingCategory = category;
            this.deleteDialog = true;
        },

        async confirmDelete() {
            if (!this.deletingCategory) return;

            this.deleteLoading = true;
            try {
                await axios.delete(`/admin/quiz-category/${this.deletingCategory.id}`);
                
                const index = this.quizCategories.findIndex(cat => cat.id === this.deletingCategory.id);
                if (index !== -1) {
                    this.quizCategories.splice(index, 1);
                }
                
                this.deleteDialog = false;
                this.showSnackbar('Xóa danh mục thành công', 'success');
            } catch (error) {
                console.error('Error deleting quiz category:', error);
                this.showSnackbar('Lỗi khi xóa danh mục', 'error');
            } finally {
                this.deleteLoading = false;
            }
        },

        closeEditDialog() {
            this.editDialog = false;
            this.editingCategory = {};
        },

        closeDeleteDialog() {
            this.deleteDialog = false;
            this.deletingCategory = null;
        },

        showSnackbar(text, color = 'success') {
            this.snackbarText = text;
            this.snackbarColor = color;
            this.snackbar = true;
        }
    }
}
</script>

<style scoped>
/* Add any specific styles if needed */
</style> 